exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2VhTC{background:#1e1f22;padding-top:40px;padding-top:2.5rem;padding-bottom:40px;padding-bottom:2.5rem;margin-top:160px;margin-top:10rem}._2VhTC>._2L6Na{width:1920px;width:120rem;margin:0 auto;display:flex;align-items:center;justify-content:space-between}._2PrUc p{font-size:22.4px;font-size:1.4rem;color:#f5f5f5;font-family:Lato,sans-serif;line-height:24px;line-height:1.5rem;letter-spacing:0}.cC0iI img{height:30px;margin-left:19.2px;margin-left:1.2rem}@media (max-width:900px){._2VhTC>._2L6Na{width:auto;padding:0 2rem}}@media (max-width:486px){._2VhTC{padding-top:1rem;padding-bottom:1rem;margin-top:5rem}._2VhTC>._2L6Na{justify-content:center;padding:0}._2PrUc p{font-size:.95rem}.cC0iI{display:none}}", ""]);

// exports
exports.locals = {
	"elastic": "_2VhTC",
	"elastic__container": "_2L6Na",
	"elastic__footer-text": "_2PrUc",
	"elastic__footer-download": "cC0iI"
};